import React from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { API_USERS } from '../../../api/users';
import useToast from '../../../hooks/useToast';

export default function ConfirmEmail({ open, closeModal, user, setSelectUserFull }) {
  const { t } = useTranslation();
  const { successToast } = useToast();
  const title = `${t('User email confirmation')} ${user.login}`;

  const onSaveClick = () => {
    API_USERS.info
      .update({ emailConfirm: true, userId: user.userId })
      .then((e) => {
        setSelectUserFull((prev) => ({ ...prev, emailConfirmed: true }));
        successToast('Email successfully confirmed');
        closeModal();
      })
      .catch(console.error);
  };

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={title}
      maxWidth="xs"
      onSaveClick={onSaveClick}
      saveText="Confirm">
      <Typography color="textSecondary">
        {t('Confirm')} {user.emailAddress} ?
      </Typography>
    </InfoDialog>
  );
}
